import { success } from "App/popupMessage";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getPasswordPolicy: () => ({
        type: actionTypes.GET_PASSWORD_POLICY,
        payload: {
            promise: () => api.getPasswordPolicy()
        }
    }),
    savePasswordPolicy: (changes) => ({
        type: actionTypes.SAVE_PASSWORD_POLICY,
        payload: {
            promise: () => api.savePasswordPolicy(changes)
        },
        completed: (dispatch) => {
            dispatch(success(locale.PASSWORD_POLICY_SAVED_SUCCESSFULLY));
        }
    })
};
